(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[862],{

/***/ 12436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(54073),
    isObject = __webpack_require__(29259);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 65235:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[[...docs-slug]]",
      function () {
        return __webpack_require__(10603);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _docs_slug_page; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var index_es = __webpack_require__(95096);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(26004);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(43400);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(59452);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(56042);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Typography/Typography.js
var Typography = __webpack_require__(38079);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(76358);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(9945);
// EXTERNAL MODULE: ./src/components/icons/index.ts + 20 modules
var icons = __webpack_require__(74862);
// EXTERNAL MODULE: ./src/components/link.tsx
var components_link = __webpack_require__(45378);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/lodash/throttle.js
var throttle = __webpack_require__(12436);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ../../node_modules/next-mdx-remote/dist/index.js + 2 modules
var dist = __webpack_require__(70021);
// EXTERNAL MODULE: ./src/components/context/page-headings-context.ts
var page_headings_context = __webpack_require__(21063);
// EXTERNAL MODULE: ./src/components/mdx/mdx-components.tsx + 10 modules
var mdx_components = __webpack_require__(44652);
;// CONCATENATED MODULE: ./src/components/mdx/mdx-page-content.tsx











var MDX_TEXT_CONTENT_MAX_WIDTH = 680;
var detectHeadingFromScrollTimer = undefined;
var MdxPageContent = function(_param) {
    var serializedPage = _param.serializedPage, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "serializedPage"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([]), headings = ref[0], setHeadings = ref[1];
    var detectHeadingFromScroll = (0,react.useRef)(true);
    var currentHeading = (0,react.useRef)(undefined);
    var headingsRef = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        setHeadings([]);
        return function() {
            currentHeading.current = undefined;
            setHeadings([]);
        };
    }, [
        serializedPage
    ]);
    var scrolledOnce = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (headings.length) {
            var ref, ref1;
            var ref2;
            var anchor = (ref2 = (ref = router.asPath.match(/(?:#)(.*?)(?:\?|$)/)) === null || ref === void 0 ? void 0 : ref[1]) !== null && ref2 !== void 0 ? ref2 : "";
            var headingWithCurrentAnchor = headings.find(function(heading) {
                return heading.anchor === anchor;
            });
            var previousRoute = sessionStorage.getItem("previousRoute");
            var shouldScrollToAnchor = // if anchor is empty and we haven't scrolled, prevent it
            anchor === "" && scrolledOnce.current || // if anchor is not empty, always allow scroll
            anchor !== "" || // OR if previous path is either a docs or spec page
            (previousRoute === null || previousRoute === void 0 ? void 0 : previousRoute.includes("/docs")) && ((ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes("/docs"));
            if (!scrolledOnce.current) {
                scrolledOnce.current = true;
            }
            if (anchor === "" && shouldScrollToAnchor) {
                currentHeading.current = headings[0];
                detectHeadingFromScroll.current = false;
                window.scrollTo({
                    top: 0
                });
                if (detectHeadingFromScrollTimer) {
                    clearTimeout(detectHeadingFromScrollTimer);
                }
                detectHeadingFromScrollTimer = setTimeout(function() {
                    detectHeadingFromScroll.current = true;
                }, 1500);
            } else if (headingWithCurrentAnchor && shouldScrollToAnchor && (!currentHeading.current || headingWithCurrentAnchor.element !== currentHeading.current.element) && document.body.contains(headingWithCurrentAnchor.element)) {
                currentHeading.current = headingWithCurrentAnchor;
                detectHeadingFromScroll.current = false;
                var ref3 = headingWithCurrentAnchor.element.getBoundingClientRect(), yPosition = ref3.y;
                window.scrollTo({
                    top: yPosition + window.scrollY - 100
                });
                if (detectHeadingFromScrollTimer) {
                    clearTimeout(detectHeadingFromScrollTimer);
                }
                detectHeadingFromScrollTimer = setTimeout(function() {
                    detectHeadingFromScroll.current = true;
                }, 1500);
            }
        }
        return function() {
            if (detectHeadingFromScrollTimer) {
                clearTimeout(detectHeadingFromScrollTimer);
            }
        };
    }, [
        headings,
        router.asPath
    ]);
    (0,react.useEffect)(function() {
        headingsRef.current = headings;
    }, [
        headings
    ]);
    (0,react.useEffect)(function() {
        var onScroll = function() {
            if (!detectHeadingFromScroll.current || headingsRef.current.length === 0) {
                return;
            }
            var headingAtScrollPosition = headingsRef.current[0];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = headingsRef.current.slice(1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var heading = _step.value;
                    var element = heading.element;
                    var top = element.getBoundingClientRect().top;
                    if (top < 150 && headingAtScrollPosition.element.getBoundingClientRect().top < top) {
                        headingAtScrollPosition = heading;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var asPath = router.asPath;
            if (headingAtScrollPosition.anchor ? !asPath.endsWith("#".concat(headingAtScrollPosition.anchor)) : asPath !== asPath.split("#")[0]) {
                currentHeading.current = headingAtScrollPosition;
                void router.replace("".concat(asPath.split("#")[0]).concat(headingAtScrollPosition.anchor ? "#".concat(headingAtScrollPosition.anchor) : ""), undefined, {
                    shallow: true
                }).catch(function() {
                // Prevents unhandled "Cancel rendering route" error
                // Happens during fast scrolling between page sections
                });
            }
        };
        var throttledOnScroll = throttle_default()(onScroll, 1000);
        window.addEventListener("scroll", throttledOnScroll);
        return function() {
            window.removeEventListener("scroll", throttledOnScroll);
        };
    }, [
        router
    ]);
    var contextValue = (0,react.useMemo)(function() {
        return {
            headings: headings,
            setHeadings: setHeadings
        };
    }, [
        headings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(page_headings_context/* default.Provider */.Z.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, boxProps), {
            sx: {
                width: "100%",
                overflow: "auto",
                "& > :not(.info-card-wrapper, .github-info-card), > a:not(.info-card-wrapper) > *": {
                    maxWidth: {
                        xs: "100%",
                        sm: MDX_TEXT_CONTENT_MAX_WIDTH
                    }
                },
                /** Headers that come after headers shouldn't have a top margin */ "& h2 + h3, h2 + h4, h2 + h5, h3 + h4, h3 + h5, h4 + h5": {
                    marginTop: 0
                },
                "& > h1:first-of-type": {
                    marginTop: 0
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MDXRemote */.R, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, serializedPage), {
                components: mdx_components/* mdxComponents */.d
            }))
        }))
    });
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(42575);
;// CONCATENATED MODULE: ./src/components/page-nav-links.tsx








var NavArrowIcon = (0,styled/* default */.ZP)(icons/* FontAwesomeIcon */.GN)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.purple[300],
        fontSize: 15,
        marginTop: theme.spacing(0.8),
        position: "relative",
        left: 0,
        transition: theme.transitions.create("left")
    };
});
var PageNavLinks = function(_param) {
    var prevPage = _param.prevPage, nextPage = _param.nextPage, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "prevPage",
        "nextPage"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var hideIcons = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down(1050));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        display: "flex",
        justifyContent: "space-between"
    }, boxProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: prevPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    display: "flex",
                    alignItems: "flex-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: theme.palette.gray[70]
                                },
                                component: "p",
                                variant: "bpSmallCopy",
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                sx: {
                                    marginLeft: hideIcons ? 0 : "-31px",
                                    "& svg": {
                                        display: hideIcons ? "none" : "inherit",
                                        ":hover": {
                                            left: "-".concat(theme.spacing(1))
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavArrowIcon, {
                                        sx: {
                                            marginRight: 2
                                        },
                                        icon: index_es/* faArrowLeft */.acZ
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                        sx: {
                                            maxWidth: hideIcons ? 150 : 200,
                                            ":hover": {
                                                color: theme.palette.purple[800]
                                            }
                                        },
                                        href: prevPage.href,
                                        children: prevPage.title
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: nextPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.gray[70]
                            },
                            component: "p",
                            variant: "bpSmallCopy",
                            children: "Next"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            sx: {
                                marginRight: hideIcons ? 0 : "-31px",
                                "& svg": {
                                    display: hideIcons ? "none" : "inherit",
                                    ":hover": {
                                        left: theme.spacing(1)
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                    sx: {
                                        textAlign: "right",
                                        maxWidth: hideIcons ? 150 : 200,
                                        ":hover": {
                                            color: theme.palette.purple[800]
                                        }
                                    },
                                    href: nextPage.href,
                                    children: nextPage.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavArrowIcon, {
                                    sx: {
                                        marginLeft: 2
                                    },
                                    icon: index_es/* faArrowRight */.eFW
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(3023);
// EXTERNAL MODULE: ../../node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(96221);
// EXTERNAL MODULE: ./src/theme/index.ts + 25 modules
var theme = __webpack_require__(92230);
// EXTERNAL MODULE: ./src/util/html-utils.tsx
var html_utils = __webpack_require__(13514);
// EXTERNAL MODULE: ./src/components/navbar.tsx + 21 modules
var navbar = __webpack_require__(93296);
// EXTERNAL MODULE: ./src/components/shared.ts
var shared = __webpack_require__(72281);
;// CONCATENATED MODULE: ./src/components/page-sidebar.tsx

















var SIDEBAR_WIDTH = 300;
var SidebarLink = (0,styled/* default */.ZP)(components_link/* Link */.r)(function(param) {
    var theme = param.theme;
    return {
        display: "block",
        lineHeight: "1.25em",
        transition: theme.transitions.create([
            "color"
        ]),
        color: theme.palette.gray[80],
        ":hover": {
            color: theme.palette.purple[600]
        },
        fontWeight: 500,
        fontSize: 15,
        paddingTop: 8,
        paddingBottom: 8,
        wordBreak: "break-word"
    };
});
var highlightSection = function(isSectionSelected) {
    return {
        borderLeft: "3px solid ".concat(isSectionSelected ? theme/* theme.palette.purple.700 */.r.palette.purple[700] : "white")
    };
};
var SidebarPageSection = function(param) {
    var _depth = param.depth, depth = _depth === void 0 ? 1 : _depth, _isSelectedByDefault = param.isSelectedByDefault, isSelectedByDefault = _isSelectedByDefault === void 0 ? false : _isSelectedByDefault, pageHref = param.pageHref, section = param.section, setSelectedAnchorElement = param.setSelectedAnchorElement, openedPages = param.openedPages, setOpenedPages = param.setOpenedPages;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    var pathWithoutParams = (0,shared/* generatePathWithoutParams */.L)(asPath);
    var sectionTitle = section.title, sectionAnchor = section.anchor, subSections = section.subSections;
    var sectionHref = sectionAnchor ? "".concat(pageHref, "#").concat(sectionAnchor) : pageHref;
    var isSectionSelected = pathWithoutParams === sectionHref || isSelectedByDefault && (pathWithoutParams === pageHref || pathWithoutParams === "".concat(pageHref, "#"));
    var hasSelectedSubSection = (subSections === null || subSections === void 0 ? void 0 : subSections.find(function(param) {
        var subSectionAnchor = param.anchor;
        return pathWithoutParams === "".concat(pageHref, "#").concat(subSectionAnchor);
    })) !== undefined;
    var isSectionOpen = openedPages.includes(sectionHref);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                visibility: "inherit",
                bgcolor: isSectionSelected ? function(theme) {
                    return theme.palette.purple[100];
                } : "white",
                pr: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarLink, {
                        replace: true,
                        ref: function(ref) {
                            if (ref && isSectionSelected) {
                                setSelectedAnchorElement(ref);
                            }
                        },
                        href: sectionHref,
                        sx: function(theme) {
                            return (0,_object_spread/* default */.Z)({
                                paddingLeft: depth * 2 + 1.25,
                                color: isSectionSelected ? theme.palette.purple[700] : theme.palette.gray[80]
                            }, highlightSection(isSectionSelected));
                        },
                        children: (0,html_utils/* parseHTML */.r)(sectionTitle)
                    }),
                    subSections && subSections.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!hasSelectedSubSection) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            router.push(sectionHref)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        setOpenedPages(function(prev) {
                                            return prev.includes(sectionHref) ? prev.filter(function(prevHref) {
                                                return prevHref !== sectionHref;
                                            }) : (0,_to_consumable_array/* default */.Z)(prev).concat([
                                                sectionHref
                                            ]);
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        sx: function(theme) {
                            return {
                                padding: 0,
                                marginLeft: 1,
                                transition: theme.transitions.create("transform"),
                                transform: "rotate(".concat(isSectionOpen ? "90deg" : "0deg", ")"),
                                "& svg": {
                                    color: isSectionSelected ? theme.palette.purple[700] : theme.palette.gray[50]
                                }
                            };
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FontAwesomeIcon */.GN, {
                            icon: index_es/* faChevronRight */._tD,
                            sx: {
                                fontSize: 14
                            }
                        })
                    }) : null
                ]
            }),
            subSections && subSections.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: isSectionOpen,
                children: subSections.map(function(subSection) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarPageSection, {
                        depth: depth + 1,
                        pageHref: pageHref,
                        section: subSection,
                        setSelectedAnchorElement: setSelectedAnchorElement,
                        openedPages: openedPages,
                        setOpenedPages: setOpenedPages
                    }, subSection.anchor);
                })
            }) : null
        ]
    });
};
var SidebarPage = function(param) {
    var _depth = param.depth, depth = _depth === void 0 ? 0 : _depth, page = param.page, setSelectedAnchorElement = param.setSelectedAnchorElement, openedPages = param.openedPages, setOpenedPages = param.setOpenedPages;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    var pathWithoutParams = (0,shared/* generatePathWithoutParams */.L)(asPath);
    var href = page.href, title = page.title, sections = page.sections, subPages = page.subPages;
    var isSelected = pathWithoutParams === href || pathWithoutParams === "".concat(href, "#");
    var isOpen = openedPages.includes(href);
    var ref, ref1;
    var hasChildren = ((ref = sections === null || sections === void 0 ? void 0 : sections.length) !== null && ref !== void 0 ? ref : 0) + ((ref1 = subPages === null || subPages === void 0 ? void 0 : subPages.length) !== null && ref1 !== void 0 ? ref1 : 0) > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                bgcolor: isSelected ? function(theme) {
                    return theme.palette.purple[100];
                } : "white",
                pr: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarLink, {
                        ref: function(ref) {
                            if (ref && isSelected) {
                                setSelectedAnchorElement(ref);
                            }
                        },
                        scroll: !(asPath === null || asPath === void 0 ? void 0 : asPath.startsWith("/docs")) && !(asPath === null || asPath === void 0 ? void 0 : asPath.startsWith("/spec")),
                        href: href,
                        sx: function(theme) {
                            return (0,_object_spread/* default */.Z)({
                                alignSelf: "flex-start",
                                color: isSelected ? theme.palette.purple[800] : theme.palette.gray[80],
                                paddingLeft: depth * 2 + 1.25
                            }, highlightSection(isSelected));
                        },
                        children: title
                    }),
                    hasChildren ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!asPath.startsWith("".concat(href, "#"))) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            router.push(href)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        setOpenedPages(function(prev) {
                                            return prev.includes(href) ? prev.filter(function(prevHref) {
                                                return prevHref !== href;
                                            }) : depth === 0 ? [
                                                href
                                            ] : (0,_to_consumable_array/* default */.Z)(prev).concat([
                                                href
                                            ]);
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        sx: function(theme) {
                            return {
                                padding: 0,
                                marginLeft: 1,
                                transition: theme.transitions.create("transform"),
                                transform: "rotate(".concat(isOpen ? "90deg" : "0deg", ")"),
                                "& svg": {
                                    color: isSelected ? theme.palette.purple[800] : theme.palette.gray[50]
                                }
                            };
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FontAwesomeIcon */.GN, {
                            icon: index_es/* faChevronRight */._tD,
                            sx: {
                                fontSize: 14
                            }
                        })
                    }) : null
                ]
            }),
            hasChildren ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse/* default */.Z, {
                in: isOpen,
                children: [
                    sections.map(function(section) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarPageSection, {
                            depth: depth + 1,
                            pageHref: href,
                            section: section,
                            setSelectedAnchorElement: setSelectedAnchorElement,
                            openedPages: openedPages,
                            setOpenedPages: setOpenedPages
                        }, section.anchor);
                    }),
                    subPages.map(function(subpage) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarPage, {
                            depth: depth + 1,
                            page: subpage,
                            setSelectedAnchorElement: setSelectedAnchorElement,
                            openedPages: openedPages,
                            setOpenedPages: setOpenedPages
                        }, subpage.href);
                    })
                ]
            }) : null
        ]
    }, href);
};
var findSectionPath = function(href, sections, pathWithoutParams) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var section = _step.value;
            var sectionHref = "".concat(href, "#").concat(section.anchor);
            if (pathWithoutParams === sectionHref) {
                return [
                    sectionHref
                ];
            }
            if (section.subSections) {
                var result = findSectionPath(href, section.subSections, pathWithoutParams);
                if (result) {
                    return [
                        sectionHref
                    ].concat((0,_to_consumable_array/* default */.Z)(result));
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var getInitialOpenedPages = function(params) {
    var pages = params.pages, asPath = params.asPath;
    var pathWithoutParams = (0,shared/* generatePathWithoutParams */.L)(asPath);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var page = _step.value;
            var href = page.href, sections = page.sections, subPages = page.subPages;
            if (pathWithoutParams === href || pathWithoutParams === "".concat(href, "#")) {
                return [
                    href
                ];
            }
            var sectionPath = findSectionPath(href, sections, pathWithoutParams);
            if (sectionPath) {
                return [
                    href
                ].concat((0,_to_consumable_array/* default */.Z)(sectionPath));
            }
            var openSubPages = getInitialOpenedPages({
                pages: subPages,
                asPath: pathWithoutParams
            });
            if (openSubPages.length > 0) {
                return [
                    href
                ].concat((0,_to_consumable_array/* default */.Z)(openSubPages));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
};
var Sidebar = function(_param) {
    var appendices = _param.appendices, pages = _param.pages, _sx = _param.sx, sx = _sx === void 0 ? [] : _sx, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "appendices",
        "pages",
        "sx"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    var asPath = (0,next_router.useRouter)().asPath;
    var md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    var ref = (0,react.useState)(getInitialOpenedPages({
        pages: pages,
        asPath: asPath
    })), openedPages = ref[0], setOpenedPages = ref[1];
    var setSelectedAnchorElementTimeout = (0,react.useRef)(null);
    var setSelectedAnchorElement = (0,react.useCallback)(function(node) {
        if (setSelectedAnchorElementTimeout.current) {
            clearTimeout(setSelectedAnchorElementTimeout.current);
        }
        setSelectedAnchorElementTimeout.current = setTimeout(function() {
            var parent = node.offsetParent;
            var min = parent.scrollTop;
            var max = min + parent.offsetHeight - 100;
            var pos = node.offsetTop;
            if (pos <= min || pos >= max) {
                parent.scrollTop += pos - max;
            }
        }, 100);
    }, []);
    (0,react.useEffect)(function() {
        return function() {
            if (setSelectedAnchorElementTimeout.current) {
                clearTimeout(setSelectedAnchorElementTimeout.current);
            }
        };
    }, []);
    (0,react.useEffect)(function() {
        setOpenedPages(function(prev) {
            return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(getInitialOpenedPages({
                pages: pages,
                asPath: asPath
            }).filter(function(href) {
                return !prev.includes(href);
            })));
        });
    }, [
        asPath,
        pages
    ]);
    var height = md ? navbar/* DESKTOP_NAVBAR_HEIGHT */.q6 : navbar/* MOBILE_NAVBAR_HEIGHT */.hv;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, boxProps), {
        component: "aside",
        position: "sticky",
        overflow: "auto",
        width: SIDEBAR_WIDTH,
        top: "".concat(height, "px"),
        height: "calc(100vh - ".concat(height, "px)"),
        sx: [
            {
                borderRightColor: theme.palette.gray[30],
                borderRightStyle: "solid",
                borderRightWidth: 1
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(Array.isArray(sx) ? sx : [
            sx
        ])),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                p: 1.5,
                display: "flex",
                flexDirection: "column",
                transition: theme.transitions.create([
                    "padding-top",
                    "padding-bottom", 
                ]),
                wordBreak: "break-word"
            },
            children: [
                pages.length > 1 ? pages.map(function(page) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarPage, {
                        page: page,
                        setSelectedAnchorElement: setSelectedAnchorElement,
                        openedPages: openedPages,
                        setOpenedPages: setOpenedPages
                    }, page.href);
                }) : pages.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        pages[0].sections.map(function(section, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarPageSection, {
                                isSelectedByDefault: i === 0,
                                depth: 0,
                                pageHref: pages[0].href,
                                section: section,
                                setSelectedAnchorElement: setSelectedAnchorElement,
                                openedPages: openedPages,
                                setOpenedPages: setOpenedPages
                            }, section.anchor);
                        }),
                        pages[0].subPages.map(function(subpage) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarPage, {
                                depth: 0,
                                page: subpage,
                                setSelectedAnchorElement: setSelectedAnchorElement,
                                openedPages: openedPages,
                                setOpenedPages: setOpenedPages
                            }, subpage.href);
                        })
                    ]
                }) : null,
                appendices && appendices.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                marginBottom: 2
                            }
                        }),
                        appendices.map(function(page) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarPage, {
                                page: page,
                                setSelectedAnchorElement: setSelectedAnchorElement,
                                openedPages: openedPages,
                                setOpenedPages: setOpenedPages
                            }, page.href);
                        })
                    ]
                }) : null
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/pages/docs/docs-content.tsx









var getParentPages = function(pages, currentPage) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var page = _step.value;
            if (page.href === currentPage.href) {
                return [];
            }
            var subParents = getParentPages(page.subPages, currentPage);
            if (subParents) {
                return [
                    page
                ].concat((0,_to_consumable_array/* default */.Z)(subParents));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var DocsContent = function(param) {
    var title = param.title, subtitle = param.subtitle, content = param.content, pages = param.pages, _flatPages = param.flatPages, flatPages = _flatPages === void 0 ? pages : _flatPages, currentPage = param.currentPage, appendices = param.appendices;
    var theme = (0,useTheme/* default */.Z)();
    var md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    var allPages = (0,_to_consumable_array/* default */.Z)(flatPages).concat((0,_to_consumable_array/* default */.Z)(appendices !== null && appendices !== void 0 ? appendices : []));
    var currentPageIndex = currentPage ? allPages.indexOf(currentPage) : -1;
    var prevPage = currentPageIndex > 0 ? allPages[currentPageIndex - 1] : undefined;
    var nextPage = currentPageIndex < allPages.length - 1 ? allPages[currentPageIndex + 1] : undefined;
    var hasMultiplePages = allPages.length > 0;
    var parents = currentPage ? getParentPages(pages, currentPage) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: "flex-start",
        children: [
            md ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {
                flexGrow: 0,
                marginRight: "62px",
                pages: pages,
                appendices: appendices
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                sx: {
                    margin: 0,
                    marginTop: {
                        xs: 5,
                        md: 8
                    },
                    width: "inherit",
                    maxWidth: "100%"
                },
                children: [
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "bpTitle",
                        sx: {
                            marginBottom: 2
                        },
                        children: title
                    }) : null,
                    subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "bpSubtitle",
                        maxWidth: 750,
                        sx: {
                            marginBottom: 6
                        },
                        children: subtitle
                    }) : null,
                    parents ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                        in: md && !!parents && parents.length > 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FontAwesomeIcon */.GN, {
                                sx: {
                                    fontSize: 14,
                                    color: function(param) {
                                        var palette = param.palette;
                                        return palette.gray[40];
                                    }
                                },
                                icon: index_es/* faChevronRight */._tD
                            }),
                            sx: {
                                marginBottom: 2,
                                marginLeft: 0.25
                            },
                            children: parents.map(function(param, i, all) {
                                var href = param.href, parentTitle = param.title;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                    href: href,
                                    sx: {
                                        textTransform: "uppercase",
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        parentTitle,
                                        i === all.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FontAwesomeIcon */.GN, {
                                            sx: {
                                                fontSize: 14,
                                                color: function(param) {
                                                    var palette = param.palette;
                                                    return palette.gray[40];
                                                },
                                                marginLeft: 1
                                            },
                                            icon: index_es/* faChevronRight */._tD
                                        }) : null
                                    ]
                                }, href);
                            })
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: hasMultiplePages ? 4 : 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MdxPageContent, {
                            flexGrow: 1,
                            serializedPage: content
                        })
                    }),
                    hasMultiplePages ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavLinks, {
                        prevPage: prevPage,
                        nextPage: nextPage,
                        sx: {
                            maxWidth: {
                                sx: "100%",
                                sm: MDX_TEXT_CONTENT_MAX_WIDTH
                            },
                            marginBottom: {
                                xs: 8,
                                md: 14
                            }
                        }
                    }) : null
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/context/site-map-context.ts
var site_map_context = __webpack_require__(6738);
;// CONCATENATED MODULE: ./src/pages/docs/[[...docs-slug]].page.tsx








var DocsPage = function(param) {
    var serializedPage = param.serializedPage;
    var asPath = (0,next_router.useRouter)().asPath;
    var ref = (0,react.useContext)(site_map_context/* default */.Z), allPages = ref.pages;
    var pathWithoutParams = (0,shared/* generatePathWithoutParams */.L)(asPath);
    var subPages = allPages.find(function(param) {
        var title = param.title;
        return title === "Documentation";
    }).subPages;
    var flatSubPages = subPages.flatMap(function(page) {
        return [
            page
        ].concat((0,_to_consumable_array/* default */.Z)(page.subPages));
    });
    var currentPage = flatSubPages.find(function(param) {
        var href = param.href;
        return pathWithoutParams === href || (pathWithoutParams === null || pathWithoutParams === void 0 ? void 0 : pathWithoutParams.startsWith("".concat(href, "#")));
    });
    var isSpec = currentPage === null || currentPage === void 0 ? void 0 : currentPage.href.startsWith("/docs/spec");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Block Protocol – ".concat(isSpec ? "Specification" : "Documentation")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DocsContent, {
                content: serializedPage,
                pages: subPages,
                flatPages: flatSubPages,
                currentPage: currentPage
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _docs_slug_page = (DocsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1,652,774,888,179], function() { return __webpack_exec__(65235); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);